/** JWT з localStorage или Redux (после initAuth / login) */
export function getAuthToken(getState) {
  const fromStorage = localStorage.getItem('token');
  if (fromStorage) {
    return fromStorage;
  }
  if (getState) {
    const user = getState().user?.currentUser;
    if (user?.access_token) {
      return user.access_token;
    }
  }
  return null;
}
